// AI-authored review of a student submission (backend AIReviewResponse shape).
// Shape: { id, submission_id, content, approved, approved_at,
//          approved_by_teacher_id, confidence (0..1 or null), created_at, updated_at }.
export default class AIReview {
  constructor({
    id = null,
    submission_id = null,
    content = '',
    approved = false,
    approved_at = null,
    approved_by_teacher_id = null,
    confidence = null,
    created_at = null,
    updated_at = null,
  } = {}) {
    this.id = id;
    this.submission_id = submission_id;
    this.content = content;
    this.approved = approved;
    this.approved_at = approved_at;
    this.approved_by_teacher_id = approved_by_teacher_id;
    this.confidence = confidence;
    this.created_at = created_at;
    this.updated_at = updated_at;
  }

  // Basic validation for a generate payload.
  static validate(data) {
    if (!data.submission_id) {
      throw new Error('Submission ID is required');
    }
  }

  // Confidence as a 0..100 integer, or null when unknown.
  get confidencePercent() {
    if (this.confidence === null || this.confidence === undefined) return null;
    return Math.round(this.confidence * 100);
  }

  // Bootstrap-5 badge class for the confidence level (colour by threshold).
  get confidenceClass() {
    const p = this.confidencePercent;
    if (p === null) return 'bg-secondary';
    if (p >= 80) return 'bg-success';
    if (p >= 50) return 'bg-warning text-dark';
    return 'bg-danger';
  }
}
